import { takeLatest, put, call } from 'redux-saga/effects';
import fetchRebateApi from 'yoda-interfaces/lib/EcoRebatesNew/EcoRebatesApi';
import {
    SET_REBATE_DATA,
    FETCH_REBATE_DATA,
    ERROR_REBATE_DATA,
} from '../actionTypes/RebatesActionTypes';

function* RebatesSaga(params) {
    try {
        const response = yield call(fetchRebateApi, params?.payload);
        const rebateData = response.data;
        if (rebateData?.rebateResponse) {
            yield put({
                type: SET_REBATE_DATA,
                payload: rebateData,
            });
        } else {
            yield put({
                type: ERROR_REBATE_DATA,
                error: 'Rebate Data not Found',
            });
        }
    } catch (error) {
        yield put({ type: ERROR_REBATE_DATA, error });
    }
}

const watchRebateRequest = function* watchRebateRequest() {
    yield takeLatest(FETCH_REBATE_DATA, RebatesSaga);
};

watchRebateRequest.sagaName = 'watchRebateRequest';

export default watchRebateRequest;
